import {
  ParagraphEmbedHtml,
  ParagraphEmbedDiagram,
  ParagraphBlockReference,
  ParagraphImage,
  ParagraphQuote,
  ParagraphUrgency,
  ParagraphUrgencySubparagraph,
  ParagraphText,
  ParagraphMultipleEntityReference,
  ParagraphFAQ,
  ParagraphCheckList,
  ParagraphStepPlan,
  ParagraphCTA,
  ParagraphWebform,
  ParagraphTip,
  ParagraphDownload,
  ParagraphLinkThrough,
  ParagraphNewsOverview,
  ParagraphResearchOverview,
  ParagraphCasesOverview,
  ParagraphWizardResultsOverview,
  Video,
  ParagraphHighlight,
  ParagraphHighlightedItems,
  ParagraphExternalPublicationsOverview,
  ParagraphFeedback,
  ParagraphGetStarted,
  ParagraphContactInformation,
  ParagraphDossierMenuOverview,
  ParagraphProduct,
  ParagraphAgendaOverview,
  ParagraphAgendaUpcoming,
  ParagraphNewsOverviewHighlighted,
  ParagraphMilestones,
  ParagraphExplainerSlider,
  ParagraphCTAMijlpalen,
  ParagraphToolkit,
  ParagraphMap,
  ParagraphThemeContentOverview,
  ParagraphPriceCalculator,
  ParagraphObjectives,
  ParagraphObjective,
  ParagraphScores,
  ParagraphTextMedia,
  ParagraphDossierContent,
  ParagraphTextEmbed,
  ParagraphHighlightedPartners,
} from '../implementations';

const mappers = {
  dossier_menu_overzicht: ParagraphDossierMenuOverview,
  html_embed: ParagraphEmbedHtml,
  diagram_embed: ParagraphEmbedDiagram,
  checklist_paragraph: ParagraphCheckList,
  step_by_step_plan: ParagraphStepPlan,
  block_reference: ParagraphBlockReference,
  image: ParagraphImage,
  text: ParagraphText,
  quote: ParagraphQuote,
  urgency: ParagraphUrgency,
  urgency_subparagraph: ParagraphUrgencySubparagraph,
  multiple_entity_reference: ParagraphMultipleEntityReference,
  faq: ParagraphFAQ,
  cta: ParagraphCTA,
  cta_with_icon: ParagraphCTA,
  webform_wrapper: ParagraphWebform,
  tip: ParagraphTip,
  download: ParagraphDownload,
  linkthrough: ParagraphLinkThrough,
  news_overview: ParagraphNewsOverview,
  research_overview: ParagraphResearchOverview,
  external_publications_overview: ParagraphExternalPublicationsOverview,
  cases_overview: ParagraphCasesOverview,
  wizard_results_overview: ParagraphWizardResultsOverview,
  video: Video,
  highlight: ParagraphHighlight,
  highlighted_items: ParagraphHighlightedItems,
  feedback: ParagraphFeedback,
  get_started_paragraph: ParagraphGetStarted,
  contact_information: ParagraphContactInformation,
  product: ParagraphProduct,
  overview_agenda: ParagraphAgendaOverview,
  overview_agenda_intro: ParagraphAgendaUpcoming,
  overview_news_intro: ParagraphNewsOverviewHighlighted,
  milestones: ParagraphMilestones,
  explainer_slider: ParagraphExplainerSlider,
  cta_mijlpalen: ParagraphCTAMijlpalen,
  toolkit: ParagraphToolkit,
  map: ParagraphMap,
  product_price_calculator_block: ParagraphPriceCalculator,
  theme_content_overview: ParagraphThemeContentOverview,
  objectives: ParagraphObjectives,
  objective: ParagraphObjective,
  scores: ParagraphScores,
  text_media: ParagraphTextMedia,
  text_social_post: ParagraphTextEmbed,
  dossier_content: ParagraphDossierContent,
  highlighted_partners: ParagraphHighlightedPartners,
};

export default mappers;
